import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { GeoMultiMethodItem } from '@/models/ps-management/multi-methods.model';

export default class GetGeoMultiMethodRequest extends ApiResourceMethod<GeoMultiMethodItem> {
  public perform(multiMethodId: string): Promise<GeoMultiMethodItem> {
    return this.performer.requestWithMapper(
      { url: `${multiMethodId}` },
      (payload: BaseResponse<GeoMultiMethodItem>) => {
        return payload.data;
      },
    );
  }
}
